/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 查询当前限时抢购活动的项目信息
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  activityId: string,
  productId: number,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: good.FlashSaleDto;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/good/flashes/${productId}/${activityId}`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
